import { Tabs } from 'components/core-v2'
import { Navigate, Route, Routes, useParams } from 'react-router-dom'

import { PATH } from '@/const'

import { DetailsNoteTab } from '../../components/details-note-tab'
import { DetailsPortfolioTab } from '../../components/details-portfolio-tab'
import { DetailsStrategyTab } from '../../components/details-strategy-tab'
import { DetailsTermsTab } from '../../components/details-terms-tab'
import { TradeTemplate } from '../../templates/trade-template'

export const ReportingTradeDetailsPage = () => {
  const { '*': splat, source, tradeId } = useParams()
  const [tab] = splat.split('/')

  return (
    <TradeTemplate tabValue="fees">
      <Tabs.List aria-label="Fees tabs" ruleClassName="mb-10" spacing="md">
        <Tabs.Tab
          isSelected={tab === 'note'}
          to={PATH.reportsSingleTradeDetailsNote(source, tradeId)}
          value="note"
        >
          Note
        </Tabs.Tab>
        <Tabs.Tab
          isSelected={tab === 'terms'}
          to={PATH.reportsSingleTradeDetailsTerms(source, tradeId)}
          value="terms"
        >
          Terms
        </Tabs.Tab>
        <Tabs.Tab
          isSelected={tab === 'portfolio'}
          to={PATH.reportsSingleTradeDetailsPortfolioOverview(source, tradeId)}
          value="portfolio"
        >
          Portfolio
        </Tabs.Tab>
        <Tabs.Tab
          isSelected={tab === 'strategy'}
          to={PATH.reportsSingleTradeDetailsStrategy(source, tradeId)}
          value="strategy"
        >
          Strategy
        </Tabs.Tab>
      </Tabs.List>
      <Routes>
        <Route
          element={<Navigate to={PATH.reportsSingleTradeDetailsNote(source, tradeId)} />}
          path=""
        />
        <Route element={<DetailsNoteTab />} path="note" />
        <Route element={<DetailsTermsTab />} path="terms" />
        <Route element={<DetailsPortfolioTab />} path="portfolio/*" />
        <Route element={<DetailsStrategyTab />} path="strategy" />
      </Routes>
    </TradeTemplate>
  )
}
